import styled, { themeGet, device, css } from "@styled";

export const SectionWrap = styled.section`
    padding-block-start: 60px;
    padding-block-end: 60px;
    margin: 0 120px 0 120px;
    ${device.medium} {
        padding-block-start: 80px;
        padding-block-end: 80px;
        margin: 0 160px 0 160px;
    }
    ${device.large} {
        padding-block-start: 100px;
        padding-block-end: 100px;
        margin: 0 200px 0 200px;
    }
    ${({ $layout }) =>
        $layout === 1 &&
        css`
            background-color: #f8f8f8;
        `}
`;

export const ContentBox = styled.div`
    padding: 0px;
    margin-block-start: 20px;
    background: "#fcfcfc";
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    font-family: "MicrosoftJhengHei", 华文细黑, "Microsoft YaHei", 微软雅黑,
        STHeiti, MingLiu;
`;

export const StyleHeading = styled.div`
    font-weight: 200;
    position: relative;
    line-height: 1.4;
    padding-inline-start: 20px;
    margin-block-end: 10px;
    margin-block-end: 30px;
    &:before {
        position: absolute;
        content: "";
        left: 0px;
        top: 50%;
        width: 4px;
        height: 94%;
        transform: translateY(-50%);
        background-color: ${themeGet("colors.secondary")};
    }
`;
export const Content = styled.div`
    margin: 40px;
    text-align: justify;
`;

export const ContentBoxTitle = styled.h5`
    font-weight: 500;
    line-height: 1.25;
    margin-block-end: 20px;
`;

export const ContentBoxText = styled.p`
    font-size: 16px;
    line-height: 1.67;
`;
export const ContentImage = styled.div`
    padding-left: 0;
`;

export const ContentBoxImage = styled.figure`
    text-align: center;
    img {
        border-radius: ${themeGet("radii.md")};
    }
`;
